import React from 'react';
import { StyledText } from './style';

const TextSmall = ({ className, children }) => (
  <StyledText className={className}>{children}</StyledText>
);

export default TextSmall;
